<template>
    <el-dialog
        title="新建列配置标签"
        :visible="true"
        top="10%"
        width="400px"
        :close-on-click-modal="false"
        :before-close="dialogBeforeClose"
        class="add-label-dialog-performance"
    >
        <el-form ref="form" :model="form" :rules="formRules">
            <el-form-item label="标签名称:" label-width="85px" prop="tabName">
                <el-input
                    v-model="form.tabName"
                    placeholder="必填"
                    maxlength="255"
                ></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="dialogBeforeClose">取 消</el-button>
            <el-button type="primary" :loading="btnLoading" @click="handleSubmit">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { tabAdd } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
export default {
    data () {
        return {
            btnLoading: false,
            dialogVisible: false,
            form: {
                tabName: ''
            },
            formRules: {
                tabName: [
                    { required: true, message: '请填写标签名称', trigger: 'blur' }
                ]
            }
        };
    },
    props: {
        columnList: {
            required: true,
            type: String,
            default () {
                return '';
            }
        },
        visualReportDefId: {
            required: true,
            type: String,
            default () {
                return '';
            }
        }
    },
    methods: {
        dialogBeforeClose () {
            this.$emit('update:isShowAddLabel', false);
        },
        handleSubmit () {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                this.btnLoading = true;
                const params = {
                    visualReportDefId: this.visualReportDefId,
                    tabName: this.form.tabName,
                    columnList: this.columnList
                };
                tabAdd(params).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('操作成功');
                        this.$emit('update:isShowAddLabel', false);
                    }
                }).finally(() => {
                    this.btnLoading = false;
                });
            });
        }
    }
};
</script>

<style lang="less">
.add-label-dialog-performance {
    .el-form-item__label {
        font-size: 14px;
    }
}
</style>
